import React from "react";
import {Button, Icon, Table} from "semantic-ui-react";
import _ from "lodash";
import TranslationFlashCard from "../StudentPages/TranslationFlashCards/TranslationFlashCard";

function SoundTable(
    {
        sounds,
        handleDownload
    }
){
    return (
        <>
            <div style={{marginBottom: 10}}>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Listen</Table.HeaderCell>
                        <Table.HeaderCell>Download</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>

                {
                    _.times(sounds.length, (i) => (
                        <>
                        <Table.Row>
                            <Table.Cell>
                                {sounds[i].name}
                            </Table.Cell>
                            <Table.Cell>
                                <Button onClick={()=>sounds[i].audio.play()} icon>
                                    <Icon name='assistive listening devices'/>
                                </Button>
                            </Table.Cell>
                            <Table.Cell>
                                <Button onClick={()=>handleDownload(sounds[i].file, sounds[i].name)}>
                                    Download
                                </Button>
                            </Table.Cell>
                        </Table.Row>
                        </>
                    ))
                }
                </Table.Body>
            </Table>
            </div>
        </>
    )
}

export default SoundTable
